export const PAYMENT_SLIP_POLICY_OPTIONS = [
  { value: 'NONE', labelKey: 'payments.policy.none' },
  { value: 'OPTIONAL', labelKey: 'payments.policy.optional' },
  { value: 'REQUIRED', labelKey: 'payments.policy.required' },
];
